
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35221',
  depVersions: {
  "documents-public-ui": "static-1.35221",
  "atom": "static-1.5390",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2784",
  "client-types": "static-1.496",
  "cssUtils": "static-1.924",
  "customer-data-filters-ui": "static-1.40925",
  "customer-data-objects": "static-1.7995",
  "customer-data-property-utils": "static-1.8404",
  "documents-lib": "static-1.35226",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.368",
  "FormsCommonComponents": "static-1.86558",
  "FormUrlGenerator": "static-2.5030",
  "foundations-theming-specialty": "static-1.2495",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5898",
  "hs-test-utils": "static-1.8334",
  "hub-http": "static-1.6516",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12100",
  "HubStyleTokens": "static-2.11793",
  "I18n": "static-7.1673",
  "icons": "static-2.683",
  "jasmine-immutable": "static-1.3325",
  "jasmine-runner": "static-1.6754",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7455",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3196",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5698",
  "quartz": "static-1.7459",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5557",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8484",
  "reference-resolvers-lite": "static-1.8406",
  "reporting-data": "static-1.68823",
  "reporting-reports": "static-1.68500",
  "reporting-snowflake": "static-1.57440",
  "reporting-testing-lib": "static-1.10756",
  "reporting-visualizations": "static-1.60898",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9255",
  "sanitize": "static-1.4775",
  "sanitize-text": "static-1.8458",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2049",
  "signup-constants": "static-1.19630",
  "signup-ui-url-generator": "static-2.8364",
  "StyleGuideUI": "static-3.502",
  "superstore": "static-1.5061",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5063",
  "ui-addon-form-validation": "static-1.11285",
  "ui-asset-management-lib": "static-1.11401",
  "ui-images": "static-2.1249",
  "UIComponents": "static-3.8739",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7379",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9958",
  "foundations-components": "static-1-ech-accordiontransition-jank.36",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1237",
  "quartz-core": "static-1.6678",
  "quick-fetch": "static-1.4130",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.4970",
  "ui-addon-i18n": "static-1.11450",
  "ui-addon-upgrades": "static-9.18389",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3621",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3736",
  "quartz-webpack": "static-1.3683",
  "foundations-assets": "static-1.5188",
  "foundations-theming": "static-1.4779",
  "hub-http-janus": "static-1.879",
  "hub-http-shared-msw-handlers": "static-1.10619",
  "hubspotter-http": "static-1.4864",
  "sassPrefix": "static-1.195",
  "conversations-skeleton-state": "static-1.7549",
  "crm-message-bus": "static-1.43762",
  "customer-data-filters-ui-msw-helpers": "static-1.23360",
  "customer-data-objects-ui-components": "static-1.13333",
  "customer-data-reference-ui-components": "static-1.13480",
  "customer-data-ui-utilities": "static-1.10132",
  "events-data-lib": "static-1.548",
  "framework-builder-read-service-client": "static-1.4220",
  "hs-resources": "static-1.495",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4054",
  "multi-account-reference-resolvers": "static-1.1308",
  "onboarding-scopes": "static-1.6756",
  "onboarding-tours": "static-1.17120",
  "pulse": "static-1.933",
  "reporting-datasets-permissions-lib": "static-1.14465",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2644",
  "trellis-components": "static-1.2663",
  "trellis-theming": "static-1.1277",
  "ui-addon-teams": "static-1.21910",
  "quartz-auth": "static-1.1134",
  "ui-business-units-lib": "static-1.9391",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9717",
  "ContentUtils": "static-1.69125",
  "customer-data-properties": "static-1.52596",
  "forms-ai-lib": "static-1.4763",
  "forms-utils-lib": "static-1.13094",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.36",
  "react-dnd-compat": "static-1.4920",
  "react-tinymce": "static-1.55980",
  "tinymce-config": "static-2.55106",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3764",
  "HeadJS": "static-2.797",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3445",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.295",
  "ui-fonts": "static-1.1055",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4616",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1124",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1847",
  "external-options-client-types": "static-1.4339",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7196",
  "quartz-i18n": "static-1.1134",
  "frontend-preferences-client": "static-1.8226",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4004",
  "reporting-client-types": "static-1.2685",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26180",
  "hubspot-apollo-client": "static-1.5180",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.36",
  "quartz-routing": "static-1.889",
  "hs-story-utils": "static-1.9728",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.537",
  "seat-types-lib": "static-1.727",
  "timezone-utils": "static-2.5547",
  "react-create-root-preference": "static-1.70",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.36",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.74",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.576",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.449",
  "quartz-test": "static-1.1134",
  "quartz-tracking": "static-1.838",
  "bend-plugin-chirp-manifest": "static-1.380",
  "chirp-fetch": "static-1.2197",
  "merchandise-lib": "static-1.278",
  "purchase-motions-components": "static-1.6366",
  "salesImages": "static-1.565",
  "ts-schema": "static-1.4294",
  "bender-build-tools": "static-1.3444",
  "bend-plugin-foundations-theming": "static-1.3262",
  "restore-request-side-panel-lib": "static-1.1675",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4959",
  "conditional-properties-service-client": "static-1.4015",
  "crm-pipelines-api-client-types": "static-1.4348",
  "event-emitter": "static-1.1256",
  "fdsr-migration-layer": "static-1.315",
  "multi-currency-client-types": "static-1.3910",
  "getting-started-shared-tasks": "static-1.19238",
  "growth-data-modal": "static-1.5898",
  "growth-onboarding-confetti": "static-1.3364",
  "growth-onboarding-next-action-utils": "static-1.2686",
  "navigation-components": "static-1.18833",
  "onboarding-tours-client": "static-1.5335",
  "onboarding-tours-utils": "static-1.1187",
  "ui-shepherd-react": "static-3.10573",
  "ui-shepherd-tracker": "static-1.7954",
  "ui-universal-auth": "static-1.9408",
  "user-context": "static-1.5423",
  "bend-plugin-pulse": "static-1.436",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.140",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10617",
  "magpie-lib": "static-1.5755",
  "navigation-messaging": "static-1.8160",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23032",
  "copilot-toolkit": "static-1.11849",
  "cms-field-types": "static-1.5117",
  "content-icons-ui": "static-1.2366",
  "integrations-lib": "static-1.17033",
  "calling-global-api": "static-1.65624",
  "calling-internal-common": "static-1.31624",
  "calling-lifecycle-internal": "static-1.67006",
  "calling-lifecycle-messages": "static-1.59300",
  "commerce-products-lib": "static-1.10527",
  "crm-index-visualization-core": "static-1.4543",
  "crm-links": "static-1.6633",
  "customer-data-properties-shared-msw-handlers": "static-1.9946",
  "file-manager-components": "static-1.24498",
  "formula-editor": "static-1.14769",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4427",
  "meetings-icalendar-utils-lib": "static-1.939",
  "object-builder-ui-client": "static-1.49674",
  "pipeline-validation-client-types": "static-1.4182",
  "property-value-citations": "static-1.3210",
  "smart-data-capture-core": "static-1.141",
  "smart-property-lib": "static-1.8295",
  "tiered-pricing": "static-1.1956",
  "topics-actions-lib": "static-1.469",
  "trial-components-library": "static-1.14109",
  "ui-addon-iframeable": "static-1.9379",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20306",
  "tinymce-themes": "static-1.57076",
  "data-token-picker": "static-1.16890",
  "hub-http-contrib": "static-1.3342",
  "interframe": "static-3.5058",
  "tinymce-data": "static-1.41191",
  "tinymce-plugins": "static-1.58220",
  "ui-addon-sales-email": "static-1.5515",
  "framework-data-schema-quick-fetch": "static-1.7101",
  "ui-addon-opt": "static-4.8667",
  "hubspot-apollo-cache": "static-1.639",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.453",
  "opentelemetry-web": "static-1.13",
  "purchase-motions-api": "static-1.6369",
  "onboarding-data-sync-lib": "static-1.2514",
  "growth-onboarding-next-action-components": "static-1.2714",
  "user-context-client": "static-1.4809",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5215",
  "nest": "static-1.540",
  "reactive-lib": "static-1.1021",
  "simple-logging-lib": "static-1.3354",
  "unified-auth-core-lib": "static-1.1204",
  "getting-started-shared-tasks-store": "static-1.18356",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1736",
  "integrations-error-boundary-lib": "static-1.14448",
  "integrations-tracking-lib": "static-1.5910",
  "native-integrations-shared-strings": "static-1.8080",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10673",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.922",
  "calling-error-reporting": "static-1.31631",
  "shared-worker-versioning": "static-1.11345",
  "calling-usage-tracker": "static-1.6839",
  "voice-sms-access-library": "static-1.2058",
  "customer-data-tracking": "static-1.7185",
  "commerce-permissions": "static-1.1080",
  "products-iframe-lib": "static-1.8591",
  "products-ui-components-shared-msw-handlers": "static-1.11001",
  "crm-index-associations-lib": "static-1.6744",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10702",
  "sales-views-client-types": "static-1.4560",
  "location-customization-utils-lib": "static-1.10096",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4451",
  "video-components-external": "static-1.12148",
  "video-data-lib": "static-1.35806",
  "bark-lib": "static-1.16815",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6191",
  "react-codemirror": "static-1.10943",
  "data-agent-kit": "static-1.650",
  "feedback-loader": "static-1.29812",
  "fsm": "static-1.4053",
  "policy-lib": "static-1.7104",
  "react-colorpicker": "static-2.10521",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10765",
  "embedded-academy-lib": "static-1.15517",
  "hubs-service-types": "static-1.1562",
  "FileManagerLib": "static-1.40138",
  "NamespacedHubStyle": "static-2.9265",
  "FileManagerCore": "static-1.39997",
  "content-assistance-lib": "static-1.8200",
  "layout-dnd-components": "static-1.12969",
  "layout-dnd-utils": "static-1.11944",
  "ui-addon-emoji-picker": "static-1.10189",
  "ui-brand-identity-lib": "static-1.16475",
  "InboxConnectUtils": "static-4.15558",
  "meetings-connect-utils-lib": "static-1.7912",
  "breeze-engine-chat-components": "static-1.714",
  "breeze-engine-core": "static-1.1014",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3311",
  "adobe-sign-auth-lib": "static-1.459",
  "ads-unified-auth-lib": "static-1.1374",
  "generic-oauth-auth-lib": "static-1.50",
  "google-sheets-integration-lib": "static-1.1028",
  "microsoft-drive-auth-lib": "static-1.142",
  "surveymonkey-integration-lib": "static-1.485",
  "slack-ui-library": "static-1.10702",
  "calling-orchestration-schema": "static-1.36835",
  "crm-record-cards-service-types": "static-1.3787",
  "content-media-composition-data-lib": "static-1.13239",
  "content-media-compositions": "static-2.17246",
  "media-bridge-lib": "static-1.19407",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16364",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4811",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.14977",
  "audio-components": "static-1.6345",
  "FileManagerImages": "static-1.37649",
  "video-components": "static-1.14150",
  "breeze-artifacts-sdk": "static-1.338",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4836",
  "video-embed": "static-1.36640",
  "ui-addon-video-player": "static-1.9006",
  "ui-coaching-tips": "static-1.29305",
  "ContentData": "static-1.69200",
  "layout-data-lib": "static-1.10269",
  "academy-service-client": "static-1.3990",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4707",
  "trellis-ecosystem": "static-1.7629",
  "ui-addon-react-router-dom": "static-1.9839",
  "wootric-nps": "static-1.7200",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4458",
  "growth-onboarding-feedback-components": "static-1.6887",
  "advanced-menus-core": "static-1.15577",
  "advanced-menus-lib": "static-1.12452",
  "ExportDialog": "static-6.10681",
  "ui-memberships-settings-lib": "static-1.34842",
  "marketplace-ui-apps-core": "static-1.19260",
  "marketplace-ui-common": "static-1.20728",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15576",
  "simple-menus-lib": "static-1.17093",
  "developer-experience-shared-components": "static-1.10842",
  "immutable-less": "static-1.4953",
  "marketplace-ui-client-types": "static-1.18135",
  "ui-addon-integrations-directory-panel": "static-2.8329",
  "ui-extensibility-client-types": "static-1.4221",
  "ai-settings-ui-library": "static-1.8352",
  "nav-meta": "static-1.30470",
  "ui-product-approvals-common": "static-1.1061",
  "apps-service-types": "static-1.4042",
  "oauth-service-types": "static-1.4541",
  "simple-data-table": "static-1.3528"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35221",
  "atom": "/atom/static-1.5390",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2784",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.924",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40925",
  "customer-data-objects": "/customer-data-objects/static-1.7995",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8404",
  "documents-lib": "/documents-lib/static-1.35226",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.368",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86558",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5030",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2495",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5898",
  "hs-test-utils": "/hs-test-utils/static-1.8334",
  "hub-http": "/hub-http/static-1.6516",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12100",
  "HubStyleTokens": "/HubStyleTokens/static-2.11793",
  "I18n": "/I18n/static-7.1673",
  "icons": "/icons/static-2.683",
  "jasmine-immutable": "/jasmine-immutable/static-1.3325",
  "jasmine-runner": "/jasmine-runner/static-1.6754",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7455",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3196",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5698",
  "quartz": "/quartz/static-1.7459",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5557",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8484",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8406",
  "reporting-data": "/reporting-data/static-1.68823",
  "reporting-reports": "/reporting-reports/static-1.68500",
  "reporting-snowflake": "/reporting-snowflake/static-1.57440",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10756",
  "reporting-visualizations": "/reporting-visualizations/static-1.60898",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9255",
  "sanitize": "/sanitize/static-1.4775",
  "sanitize-text": "/sanitize-text/static-1.8458",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2049",
  "signup-constants": "/signup-constants/static-1.19630",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8364",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "superstore": "/superstore/static-1.5061",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5063",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11285",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11401",
  "ui-images": "/ui-images/static-2.1249",
  "UIComponents": "/UIComponents/static-3.8739",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7379",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9958",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.36",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1237",
  "quartz-core": "/quartz-core/static-1.6678",
  "quick-fetch": "/quick-fetch/static-1.4130",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.4970",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11450",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18389",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3621",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3736",
  "quartz-webpack": "/quartz-webpack/static-1.3683",
  "foundations-assets": "/foundations-assets/static-1.5188",
  "foundations-theming": "/foundations-theming/static-1.4779",
  "hub-http-janus": "/hub-http-janus/static-1.879",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10619",
  "hubspotter-http": "/hubspotter-http/static-1.4864",
  "sassPrefix": "/sassPrefix/static-1.195",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7549",
  "crm-message-bus": "/crm-message-bus/static-1.43762",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23360",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13333",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13480",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10132",
  "events-data-lib": "/events-data-lib/static-1.548",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4220",
  "hs-resources": "/hs-resources/static-1.495",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4054",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1308",
  "onboarding-scopes": "/onboarding-scopes/static-1.6756",
  "onboarding-tours": "/onboarding-tours/static-1.17120",
  "pulse": "/pulse/static-1.933",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14465",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2644",
  "trellis-components": "/trellis-components/static-1.2663",
  "trellis-theming": "/trellis-theming/static-1.1277",
  "ui-addon-teams": "/ui-addon-teams/static-1.21910",
  "quartz-auth": "/quartz-auth/static-1.1134",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9391",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9717",
  "ContentUtils": "/ContentUtils/static-1.69125",
  "customer-data-properties": "/customer-data-properties/static-1.52596",
  "forms-ai-lib": "/forms-ai-lib/static-1.4763",
  "forms-utils-lib": "/forms-utils-lib/static-1.13094",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.36",
  "react-dnd-compat": "/react-dnd-compat/static-1.4920",
  "react-tinymce": "/react-tinymce/static-1.55980",
  "tinymce-config": "/tinymce-config/static-2.55106",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3764",
  "HeadJS": "/HeadJS/static-2.797",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3445",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.295",
  "ui-fonts": "/ui-fonts/static-1.1055",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4616",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1124",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1847",
  "external-options-client-types": "/external-options-client-types/static-1.4339",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7196",
  "quartz-i18n": "/quartz-i18n/static-1.1134",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8226",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4004",
  "reporting-client-types": "/reporting-client-types/static-1.2685",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26180",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5180",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.36",
  "quartz-routing": "/quartz-routing/static-1.889",
  "hs-story-utils": "/hs-story-utils/static-1.9728",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.537",
  "seat-types-lib": "/seat-types-lib/static-1.727",
  "timezone-utils": "/timezone-utils/static-2.5547",
  "react-create-root-preference": "/react-create-root-preference/static-1.70",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.36",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.74",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.576",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.449",
  "quartz-test": "/quartz-test/static-1.1134",
  "quartz-tracking": "/quartz-tracking/static-1.838",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.380",
  "chirp-fetch": "/chirp-fetch/static-1.2197",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "purchase-motions-components": "/purchase-motions-components/static-1.6366",
  "salesImages": "/salesImages/static-1.565",
  "ts-schema": "/ts-schema/static-1.4294",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3262",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1675",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4959",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4015",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4348",
  "event-emitter": "/event-emitter/static-1.1256",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.315",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3910",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19238",
  "growth-data-modal": "/growth-data-modal/static-1.5898",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3364",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2686",
  "navigation-components": "/navigation-components/static-1.18833",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5335",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1187",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10573",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7954",
  "ui-universal-auth": "/ui-universal-auth/static-1.9408",
  "user-context": "/user-context/static-1.5423",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.436",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.140",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10617",
  "magpie-lib": "/magpie-lib/static-1.5755",
  "navigation-messaging": "/navigation-messaging/static-1.8160",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23032",
  "copilot-toolkit": "/copilot-toolkit/static-1.11849",
  "cms-field-types": "/cms-field-types/static-1.5117",
  "content-icons-ui": "/content-icons-ui/static-1.2366",
  "integrations-lib": "/integrations-lib/static-1.17033",
  "calling-global-api": "/calling-global-api/static-1.65624",
  "calling-internal-common": "/calling-internal-common/static-1.31624",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67006",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59300",
  "commerce-products-lib": "/commerce-products-lib/static-1.10527",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4543",
  "crm-links": "/crm-links/static-1.6633",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9946",
  "file-manager-components": "/file-manager-components/static-1.24498",
  "formula-editor": "/formula-editor/static-1.14769",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4427",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.939",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49674",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4182",
  "property-value-citations": "/property-value-citations/static-1.3210",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.141",
  "smart-property-lib": "/smart-property-lib/static-1.8295",
  "tiered-pricing": "/tiered-pricing/static-1.1956",
  "topics-actions-lib": "/topics-actions-lib/static-1.469",
  "trial-components-library": "/trial-components-library/static-1.14109",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9379",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20306",
  "tinymce-themes": "/tinymce-themes/static-1.57076",
  "data-token-picker": "/data-token-picker/static-1.16890",
  "hub-http-contrib": "/hub-http-contrib/static-1.3342",
  "interframe": "/interframe/static-3.5058",
  "tinymce-data": "/tinymce-data/static-1.41191",
  "tinymce-plugins": "/tinymce-plugins/static-1.58220",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5515",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7101",
  "ui-addon-opt": "/ui-addon-opt/static-4.8667",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.639",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.453",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "purchase-motions-api": "/purchase-motions-api/static-1.6369",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2514",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2714",
  "user-context-client": "/user-context-client/static-1.4809",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5215",
  "nest": "/nest/static-1.540",
  "reactive-lib": "/reactive-lib/static-1.1021",
  "simple-logging-lib": "/simple-logging-lib/static-1.3354",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1204",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18356",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1736",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14448",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5910",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8080",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10673",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.922",
  "calling-error-reporting": "/calling-error-reporting/static-1.31631",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11345",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6839",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2058",
  "customer-data-tracking": "/customer-data-tracking/static-1.7185",
  "commerce-permissions": "/commerce-permissions/static-1.1080",
  "products-iframe-lib": "/products-iframe-lib/static-1.8591",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11001",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6744",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10702",
  "sales-views-client-types": "/sales-views-client-types/static-1.4560",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10096",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4451",
  "video-components-external": "/video-components-external/static-1.12148",
  "video-data-lib": "/video-data-lib/static-1.35806",
  "bark-lib": "/bark-lib/static-1.16815",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6191",
  "react-codemirror": "/react-codemirror/static-1.10943",
  "data-agent-kit": "/data-agent-kit/static-1.650",
  "feedback-loader": "/feedback-loader/static-1.29812",
  "fsm": "/fsm/static-1.4053",
  "policy-lib": "/policy-lib/static-1.7104",
  "react-colorpicker": "/react-colorpicker/static-2.10521",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10765",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15517",
  "hubs-service-types": "/hubs-service-types/static-1.1562",
  "FileManagerLib": "/FileManagerLib/static-1.40138",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9265",
  "FileManagerCore": "/FileManagerCore/static-1.39997",
  "content-assistance-lib": "/content-assistance-lib/static-1.8200",
  "layout-dnd-components": "/layout-dnd-components/static-1.12969",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11944",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10189",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16475",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15558",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7912",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.714",
  "breeze-engine-core": "/breeze-engine-core/static-1.1014",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3311",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.459",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1374",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.50",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1028",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.142",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.485",
  "slack-ui-library": "/slack-ui-library/static-1.10702",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36835",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3787",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13239",
  "content-media-compositions": "/content-media-compositions/static-2.17246",
  "media-bridge-lib": "/media-bridge-lib/static-1.19407",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16364",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4811",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.14977",
  "audio-components": "/audio-components/static-1.6345",
  "FileManagerImages": "/FileManagerImages/static-1.37649",
  "video-components": "/video-components/static-1.14150",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.338",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4836",
  "video-embed": "/video-embed/static-1.36640",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9006",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29305",
  "ContentData": "/ContentData/static-1.69200",
  "layout-data-lib": "/layout-data-lib/static-1.10269",
  "academy-service-client": "/academy-service-client/static-1.3990",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4707",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7629",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9839",
  "wootric-nps": "/wootric-nps/static-1.7200",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4458",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6887",
  "advanced-menus-core": "/advanced-menus-core/static-1.15577",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12452",
  "ExportDialog": "/ExportDialog/static-6.10681",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34842",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19260",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20728",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15576",
  "simple-menus-lib": "/simple-menus-lib/static-1.17093",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10842",
  "immutable-less": "/immutable-less/static-1.4953",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18135",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8329",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4221",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8352",
  "nav-meta": "/nav-meta/static-1.30470",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1061",
  "apps-service-types": "/apps-service-types/static-1.4042",
  "oauth-service-types": "/oauth-service-types/static-1.4541",
  "simple-data-table": "/simple-data-table/static-1.3528"
}
};
